import React from "react"
import { MasterButton, Modal } from "App/Component/ui"
import { WarningIcon } from "App/Assets"
import { Grid } from "@material-ui/core"

export function ModalForceSEP({ setShowModalForce, handleForce, sepPrev }) {
  const [disabled, setDisabled] = React.useState(false)

  return (
    <>
      <Modal title={"Perhatian"} width={"30%"} show={setShowModalForce}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "20px",
            marginBottom: "1rem",
          }}
        >
          <WarningIcon />
          <p>
            Terdapat SEP pada kunjungan sebelumnya <b>({sepPrev})</b>, apakah ingin menghapus SEP kunjungan sebelumnya  <b>({sepPrev})</b>?
          </p>
        </div>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            disabled={disabled}
            outline={true}
            className={"mr-1 mt-1"}
            type={"button"}
            color={disabled ? "secondary" : "lightgreen"}
            onClick={
              disabled
                ? () => {}
                : (e) => {
                    handleForce(false)
                    setDisabled(true)
                  }
            }
            name={disabled ? "Loading..." : "Lanjutkan Tanpa Hapus SEP"}
            size="md"
          />
          <MasterButton
            disabled={disabled}
            className={"mt-1"}
            type={"button"}
            color={disabled ? "secondary" : "danger"}
            onClick={
              disabled
                ? () => {}
                : (e) => {
                    handleForce(e, true)
                    setDisabled(true)
                  }
            }
            name={disabled ? "Loading..." : "Lanjutkan Dengan Hapus SEP"}
            size="md"
          />
        </Grid>
      </Modal>
    </>
  )
}
